<template>
  <div style="overflow-y: none">
    <!-- View/Add -->
    <user-detail
      v-if="showUserDetail"
    ></user-detail>
    
    <!-- List -->
    <user-list
      v-else
    ></user-list>

    <!-- Pagination -->
    <!-- <v-footer color="transparent">
      <div class="mx-auto py-5">
        <v-pagination
          v-model="page"
          :length="pages"
          :hidden="pages==1 || showUserDetail"
        ></v-pagination>
      </div>
    </v-footer> -->
  </div>
</template>

<script>
  export default {
    name: "Users",

    components: {
      /** view component for displaying user detail */
      UserDetail: () => import('./components/UserDetail.vue'),
      /** view component for displaying users */
      UserList: () => import('./components/UserList.vue')
    },

    // data() {
    //   return {
    //     page: 1,
    //     isLoading: false
    //   }
    // },

    // watch: {
    //   async page() {
    //     try {
    //       this.isLoading = true
    //       await this.$store.dispatch('user/fetchUsers', {page: this.page, per_page: 12, no_patient: true, update_sort: true, tma_and_doctors_only: true})
    //       this.isLoading = false
    //     }
    //     catch(e) {
    //       console.log('[error]', e)
    //       this.isLoading = false
    //     }
    //   }
    // },

    // created() {
    //   this.$store.dispatch('user/fetchUsers', {page: 1, per_page: 12, no_patient: true, update_sort: true, tma_and_doctors_only: true})
    // },

    // mounted() {
    //   //
    // },

    computed: {
      // users() {
      //   return this.$store.getters['user/users']
      // },
      // pages() {
      //   return this.$store.getters['user/pages']
      // },
      showUserDetail() {
        return !!this.$route.params.id
      },
      userIndex() {
        return this.$route.params.id
      }
    },

    methods: {
      //
    }
  }
</script>

<style lang="scss" scoped>

</style>